var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "company_website") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "captive_portal_FILL1_wght400_GRAD0_opsz20",
    d: "M102.1,206.229a8.135,8.135,0,0,1-.51-1.417,15.737,15.737,0,0,1-.365-1.812H98.25a6.4,6.4,0,0,0,1.615,2.031A6.1,6.1,0,0,0,102.1,206.229ZM97.688,201.5h3.354q-.042-.354-.052-.719t-.01-.74q0-.375.01-.76t.052-.781H97.688a6.084,6.084,0,0,0-.146.781A6.327,6.327,0,0,0,97.5,200a6.238,6.238,0,0,0,.042.729A6.174,6.174,0,0,0,97.688,201.5Zm.563-4.5h2.979a15.737,15.737,0,0,1,.365-1.812,8.135,8.135,0,0,1,.51-1.417,6.1,6.1,0,0,0-2.24,1.2A6.4,6.4,0,0,0,98.25,197Zm4.5,0h2.5a11.615,11.615,0,0,0-.542-2.115,3.793,3.793,0,0,0-.708-1.323,3.793,3.793,0,0,0-.708,1.323A11.615,11.615,0,0,0,102.75,197Zm4.021,0h2.979a6.4,6.4,0,0,0-1.615-2.031,6.1,6.1,0,0,0-2.24-1.2,8.135,8.135,0,0,1,.51,1.417A15.737,15.737,0,0,1,106.771,197Zm-2.937,11a7.423,7.423,0,0,1-3.01-.625,7.914,7.914,0,0,1-2.5-1.719,8.244,8.244,0,0,1-1.7-2.552,8.047,8.047,0,0,1,0-6.219,8.061,8.061,0,0,1,4.271-4.26,8.047,8.047,0,0,1,6.219,0,8.278,8.278,0,0,1,2.542,1.7,7.882,7.882,0,0,1,1.719,2.51,7.546,7.546,0,0,1,.625,3.042q0,.271-.01.552a5.488,5.488,0,0,1-.052.573h-1.521q.042-.25.063-.5t.021-.5a6.327,6.327,0,0,0-.042-.719,6.084,6.084,0,0,0-.146-.781h-3.354q.042.354.052.719t.01.74V201H105.5v-1.062q0-.292-.01-.656t-.052-.781h-2.875q-.042.4-.052.771t-.01.729q0,.354.01.719t.052.781H105V203h-2.25a8.982,8.982,0,0,0,.6,1.958,4.786,4.786,0,0,0,.9,1.479,3.666,3.666,0,0,0,.385-.6,6.189,6.189,0,0,0,.365-.854v2.958a4.876,4.876,0,0,1-.573.052Q104.125,208,103.833,208Zm6.375-.729L108,205.063v1.688h-1.5V202.5h4.25V204h-1.687l2.208,2.208Z",
    transform: "translate(1339 -175)",
    fill: "#758091"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyWebsite);
export default __webpack_public_path__ + "static/media/company_website.199bdab7d3782900a1b83c1a9ff9f53f.svg";
export { ForwardRef as ReactComponent };